import React from 'react'

import AdminLayout from '../../../Layouts/AdminLayout/AdminLayout'
import Icon from '../../../Components/Icon/Icon'

import './AdminDesignSystemPage.scss'

type Token = {
  name: string
  value: string
  usage: string
  swatch?: string
}

const colorTokens: Token[] = [
  { name: '--pl4-color-purple-600', value: '#663299', usage: 'Color principal Pl4nner, marca y acciones principales.', swatch: 'var(--pl4-color-purple-600)' },
  { name: '--pl4-color-violet-600', value: '#5B4BDB', usage: 'Acento moderno tomado de la propuesta Claude Design.', swatch: 'var(--pl4-color-violet-600)' },
  { name: '--pl4-color-ink-950', value: '#15172B', usage: 'Topbar oscuro SaaS y elementos de alto contraste.', swatch: 'var(--pl4-color-ink-950)' },
  { name: '--pl4-color-purple-700', value: '#5b2d88', usage: 'Hover de elementos morados.', swatch: 'var(--pl4-color-purple-700)' },
  { name: '--pl4-color-purple-800', value: '#4f2877', usage: 'Estado activo/presionado de morado.', swatch: 'var(--pl4-color-purple-800)' },
  { name: '--pl4-color-purple-050', value: '#f8f4fb', usage: 'Fondos suaves de marca.', swatch: 'var(--pl4-color-purple-050)' },
  { name: '--pl4-color-purple-border', value: '#d8c7e8', usage: 'Bordes suaves relacionados a marca.', swatch: 'var(--pl4-color-purple-border)' },
  { name: '--pl4-color-ink-900', value: '#2f2f2f', usage: 'Botones oscuros y elementos de alto contraste.', swatch: 'var(--pl4-color-ink-900)' },
  { name: '--pl4-color-ink-600', value: '#5f5f5f', usage: 'Texto e iconos secundarios.', swatch: 'var(--pl4-color-ink-600)' },
  { name: '--pl4-color-ink-200', value: '#dedbe2', usage: 'Bordes y fondos segmentados.', swatch: 'var(--pl4-color-ink-200)' },
  { name: '--pl4-color-danger', value: '#f44336', usage: 'Eliminar, errores y acciones destructivas.', swatch: 'var(--pl4-color-danger)' },
  { name: '--pl4-color-success', value: '#4b994f', usage: 'Crear, agregar, exito y estados positivos.', swatch: 'var(--pl4-color-success)' },
  { name: '--pl4-color-warning', value: '#ffc107', usage: 'Advertencias recuperables.', swatch: 'var(--pl4-color-warning)' },
  { name: '--pl4-color-info', value: '#0d6efd', usage: 'Informacion contextual.', swatch: 'var(--pl4-color-info)' },
]

const textTokens: Token[] = [
  { name: '--pl4-text-primary', value: '#2f2f2f', usage: 'Texto principal.' },
  { name: '--pl4-text-secondary', value: '#665c70', usage: 'Texto secundario y navegacion normal.' },
  { name: '--pl4-text-muted', value: '#817a88', usage: 'Ayuda, metadatos y descripciones.' },
  { name: '--pl4-text-disabled', value: '#c2c2c2', usage: 'Texto deshabilitado.' },
  { name: '--pl4-text-active', value: '#663299', usage: 'Texto activo o seleccionado.' },
  { name: '--pl4-text-hover', value: '#5b2d88', usage: 'Texto en hover.' },
]

const sizeTokens: Token[] = [
  { name: '--pl4-font-size-h1', value: '24px', usage: 'Encabezado principal.' },
  { name: '--pl4-font-size-h2', value: '20px', usage: 'Encabezado secundario.' },
  { name: '--pl4-font-size-card-title', value: '16px', usage: 'Titulos de cards.' },
  { name: '--pl4-font-size-body', value: '14px', usage: 'Texto normal.' },
  { name: '--pl4-font-size-small', value: '12px', usage: 'Texto pequeno.' },
  { name: '--pl4-font-size-helper', value: '11px', usage: 'Disclaimers y ayuda.' },
  { name: '--pl4-font-size-button', value: '13px', usage: 'Texto de botones.' },
  { name: '--pl4-font-size-tab', value: '12px', usage: 'Texto de tabs.' },
  { name: '--pl4-font-size-nav', value: '13px', usage: 'Texto de navegacion.' },
  { name: '--pl4-button-height', value: '40px', usage: 'Altura base de botones.' },
  { name: '--pl4-button-height-sm', value: '32px', usage: 'Altura de botones pequenos.' },
  { name: '--pl4-button-height-lg', value: '46px', usage: 'Altura de botones grandes.' },
  { name: '--pl4-button-radius', value: '10px', usage: 'Radio visual de botones.' },
]

const iconTokens: Token[] = [
  { name: '--pl4-icon-main-menu', value: '30px', usage: 'Iconos principales del menu.' },
  { name: '--pl4-icon-submenu', value: '18px', usage: 'Iconos de submenu.' },
  { name: '--pl4-icon-button', value: '16px', usage: 'Iconos dentro de botones.' },
  { name: '--pl4-icon-support', value: '12px', usage: 'Iconos pequenos de apoyo.' },
  { name: '--pl4-icon-tab', value: '18px', usage: 'Iconos dentro de tabs.' },
  { name: '--pl4-icon-header', value: '28px', usage: 'Iconos dentro del header.' },
]

const headerTokens: Token[] = [
  { name: '--pl4-header-height', value: '112px', usage: 'Altura recomendada del header principal.' },
  { name: '--pl4-header-padding-x', value: '24px', usage: 'Espaciado horizontal interno.' },
  { name: '--pl4-header-gap', value: '22px', usage: 'Separacion entre botones del header.' },
  { name: '--pl4-header-text-size', value: '13px', usage: 'Texto de botones del header.' },
  { name: '--pl4-header-icon-size', value: '28px', usage: 'Iconos del header.' },
  { name: '--pl4-header-bg', value: '#15172B', usage: 'Fondo del header superior.' },
  { name: '--pl4-header-border', value: '#e7e4eb', usage: 'Borde/sombra suave del header.' },
  { name: '--pl4-nav-item-radius', value: '12px', usage: 'Radio de items de navegacion principal.' },
  { name: '--pl4-nav-item-height', value: '72px', usage: 'Altura sugerida de items del menu principal.' },
  { name: '--pl4-subnav-height', value: '42px', usage: 'Altura sugerida del submenu.' },
  { name: '--pl4-tab-height', value: '38px', usage: 'Altura de tabs.' },
  { name: '--pl4-card-radius', value: '12px', usage: 'Radio base de cards.' },
]

const classTokens: Token[] = [
  { name: '.pl4-btn .pl4-btn-primary', value: 'Clase', usage: 'Boton principal morado.' },
  { name: '.pl4-btn .pl4-btn-secondary', value: 'Clase', usage: 'Boton secundario neutro.' },
  { name: '.pl4-btn .pl4-btn-dark', value: 'Clase', usage: 'Boton oscuro negro/plomo.' },
  { name: '.pl4-btn .pl4-btn-success', value: 'Clase', usage: 'Acciones de crear/agregar.' },
  { name: '.pl4-btn .pl4-btn-danger', value: 'Clase', usage: 'Acciones destructivas.' },
  { name: '.pl4-btn-icon', value: 'Clase', usage: 'Boton solo icono.' },
  { name: '.pl4-btn-sm / .pl4-btn-lg', value: 'Clase', usage: 'Variantes de tamano de boton.' },
  { name: '.pl4-tabs .pl4-tab', value: 'Clase', usage: 'Tabs segmentados.' },
  { name: '.pl4-card', value: 'Clase', usage: 'Contenedor/card base.' },
  { name: '.pl4-main-nav-item', value: 'Clase', usage: 'Referencia reutilizable para items de navegacion.' },
  { name: '.pl4-header-example', value: 'Clase', usage: 'Contenedor de ejemplo para revisar tokens de header.' },
  { name: '.pl4-state-*', value: 'Clase', usage: 'Estados success/error/warning/info/loading.' },
]

const missingItems = [
  'Escala completa de espaciados por componente',
  'Reglas finales de border radius por densidad',
  'Sombras por elevacion y uso',
  'Z-index auditado por overlays reales',
  'Breakpoints responsive documentados',
  'Inputs, selects, date pickers y textareas',
  'Modales, drawers y overlays',
  'Tooltips y popovers',
  'Badges, chips y tags',
  'Avatares y fallbacks',
  'Estados vacios',
  'Skeleton loaders',
  'Toasts/notificaciones',
  'Tablas densas y tablas de lectura',
  'Formularios y validaciones',
  'Breadcrumbs',
  'Menus contextuales',
  'Accesibilidad, contraste y focus visible',
]

const TokenTable = ({ title, tokens }: { title: string, tokens: Token[] }) => (
  <section className="ds-section">
    <div className="ds-section-header">
      <h2>{title}</h2>
    </div>
    <div className="ds-token-table">
      {tokens.map((token) => (
        <div className="ds-token-row" key={token.name}>
          <div className="ds-token-name">
            {token.swatch && <span className="ds-swatch" style={{ background: token.swatch }} />}
            <code>{token.name}</code>
          </div>
          <div className="ds-token-value">{token.value}</div>
          <div className="ds-token-usage">{token.usage}</div>
        </div>
      ))}
    </div>
  </section>
)

const AdminDesignSystemPage = () => {

  return (
    <AdminLayout title="Design System" menu="design-system">
      <div className="admin-design-system-page">
        <section className="ds-hero">
          <div>
            <p className="ds-eyebrow">Glosario visual interno</p>
            <h1>Pl4nner Design System</h1>
            <p>
              Primera base centralizada para revisar colores, tamanos, estados y clases visuales.
              Esta pagina no consume API y sirve como inventario para decidir antes de refactorizar pantallas.
            </p>
          </div>
          <div className="ds-hero-card">
            <span>Color principal</span>
            <strong>#663299</strong>
            <small>Morado Pl4nner</small>
          </div>
        </section>

        <TokenTable title="Colores" tokens={colorTokens} />
        <TokenTable title="Texto" tokens={textTokens} />
        <TokenTable title="Tipografia" tokens={sizeTokens} />
        <TokenTable title="Header" tokens={headerTokens} />
        <TokenTable title="Iconos" tokens={iconTokens} />
        <TokenTable title="Clases reutilizables" tokens={classTokens} />

        <section className="ds-section">
          <div className="ds-section-header">
            <h2>Botones</h2>
            <p>Base reutilizable: mayor presencia, mejor jerarquia, hover claro y estados visibles sin cambiar botones existentes de la app.</p>
          </div>
          <div className="ds-button-showcase">
            <div className="ds-button-panel">
              <h3>Tipos principales</h3>
              <div className="ds-demo-grid">
                <button className="pl4-btn pl4-btn-primary">Principal</button>
                <button className="pl4-btn pl4-btn-secondary">Secundario</button>
                <button className="pl4-btn pl4-btn-dark">Oscuro</button>
                <button className="pl4-btn pl4-btn-success"><i className="fas fa-plus"></i> Agregar</button>
                <button className="pl4-btn pl4-btn-danger"><i className="fas fa-trash"></i> Eliminar</button>
                <button className="pl4-btn pl4-btn-dark pl4-btn-icon" aria-label="Configuracion"><i className="fas fa-cog"></i></button>
              </div>
            </div>

            <div className="ds-button-panel">
              <h3>Estados simulados</h3>
              <div className="ds-demo-grid">
                <button className="pl4-btn pl4-btn-primary is-hover">Hover</button>
                <button className="pl4-btn pl4-btn-primary is-active">Active</button>
                <button className="pl4-btn pl4-btn-primary is-selected">Selected</button>
                <button className="pl4-btn pl4-btn-primary" disabled>Disabled</button>
                <button className="pl4-btn pl4-btn-secondary is-hover">Hover secundario</button>
                <button className="pl4-btn pl4-btn-danger is-hover">Hover danger</button>
              </div>
            </div>

            <div className="ds-button-panel">
              <h3>Tamanos</h3>
              <div className="ds-demo-grid ds-demo-grid-align">
                <button className="pl4-btn pl4-btn-secondary pl4-btn-sm">Pequeno</button>
                <button className="pl4-btn pl4-btn-primary">Normal</button>
                <button className="pl4-btn pl4-btn-dark pl4-btn-lg">Grande</button>
              </div>
            </div>

            <div className="ds-button-panel">
              <h3>Uso recomendado</h3>
              <p>En siguientes PRs se agregaran estas clases a botones reales sin cambiar comportamiento.</p>
              <div className="ds-demo-grid">
                <button className="pl4-btn pl4-btn-primary"><i className="fas fa-save"></i> Guardar</button>
                <button className="pl4-btn pl4-btn-secondary"><i className="fas fa-times"></i> Cancelar</button>
                <button className="pl4-btn pl4-btn-danger"><i className="fas fa-trash"></i> Eliminar</button>
              </div>
            </div>
          </div>
        </section>

        <section className="ds-section">
          <div className="ds-section-header">
            <h2>Tabs</h2>
            <p>Patron recomendado para tabs compactos y segmentados.</p>
          </div>
          <div className="pl4-tabs">
            <button className="pl4-tab is-active"><i className="fas fa-building"></i> Activo</button>
            <button className="pl4-tab"><i className="fas fa-hashtag"></i> Inactivo</button>
            <button className="pl4-tab is-hover"><i className="fas fa-users"></i> Hover</button>
            <button className="pl4-tab is-disabled" disabled><i className="fas fa-ban"></i> Disabled</button>
          </div>
        </section>

        <section className="ds-section">
          <div className="ds-section-header">
            <h2>Navegacion principal</h2>
            <p>Referencia visual aplicada al header y menu principal.</p>
          </div>
          <div className="ds-shell-preview">
            <div className="ds-shell-logo">PL4NNER</div>
            <div className="ds-shell-nav-item is-active"><Icon name="home" fas /> Proyectos</div>
            <div className="ds-shell-nav-item"><Icon name="users" fas /> Equipos</div>
            <div className="ds-shell-nav-item"><Icon name="calendar-alt" fas /> Programacion</div>
            <div className="ds-shell-spacer" />
            <div className="ds-shell-avatar">RM</div>
          </div>
          <div className="pl4-header-example">
            <strong className="ds-logo-word">PL4NNER</strong>
            <div className="pl4-main-nav-item is-active">
              <Icon name="home" fas />
              Proyecto
            </div>
            <div className="pl4-main-nav-item">
              <Icon name="users" fas />
              Equipos
            </div>
            <div className="pl4-main-nav-item is-hover">
              <Icon name="tasks" fas />
              Tareas
            </div>
            <div className="ds-header-spacer" />
            <button className="pl4-btn pl4-btn-dark pl4-btn-icon">
              <Icon name="bell" far />
            </button>
          </div>
        </section>

        <section className="ds-section">
          <div className="ds-section-header">
            <h2>Estados</h2>
            <p>Referencia visual para feedback y estados de UI.</p>
          </div>
          <div className="ds-demo-grid">
            <span className="pl4-state pl4-state-info">Normal</span>
            <span className="pl4-state pl4-state-info">Focus</span>
            <span className="pl4-state pl4-state-success">Success</span>
            <span className="pl4-state pl4-state-error">Error</span>
            <span className="pl4-state pl4-state-warning">Warning</span>
            <span className="pl4-state pl4-state-loading">Loading</span>
          </div>
        </section>

        <section className="ds-section">
          <div className="ds-section-header">
            <h2>Cards y acciones</h2>
          </div>
          <div className="ds-card-grid">
            <div className="pl4-card">
              <h3 className="pl4-card-title">Card base</h3>
              <p className="pl4-body">Superficie blanca, borde suave y radio moderado.</p>
              <p className="pl4-helper">Clase: .pl4-card</p>
            </div>
            <div className="pl4-card">
              <h3 className="pl4-card-title">Acciones</h3>
              <div className="ds-inline-actions">
                <button className="pl4-btn pl4-btn-success">Crear</button>
                <button className="pl4-btn pl4-btn-secondary">Editar</button>
                <button className="pl4-btn pl4-btn-danger">Eliminar</button>
              </div>
            </div>
            <div className="ds-project-card-preview">
              <button className="ds-card-menu" aria-label="Mas opciones"><i className="fas fa-ellipsis-v"></i></button>
              <div className="ds-project-icon"><i className="fas fa-folder"></i></div>
              <strong>Costa Morena 1</strong>
              <span>Card de proyecto</span>
            </div>
          </div>
        </section>

        <section className="ds-section">
          <div className="ds-section-header">
            <h2>Falta completar</h2>
            <p>Inventario recomendado para futuras etapas del sistema.</p>
          </div>
          <div className="ds-missing-grid">
            {missingItems.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </section>
      </div>
    </AdminLayout>
  )
}

export default AdminDesignSystemPage
